module.exports = __webpack_public_path__ + "static/media/navicon.f414d569.svg";